module.exports = __webpack_public_path__ + "media/images/long-page-02a1e443b0b164878cbb7336d546abc4.png";